export default __webpack_public_path__ + "static/media/briefcase.fa14472e.svg";